var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 60,
    viewBox: "0 0 140 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6658_126718)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6658_126718)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 53H45.974L90.966 8H0V53Z",
    fill: "url(#paint0_linear_6658_126718)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9835 17.0001H44.9995L45.0295 38.1301L37.2065 16.9931H29.4495L22.7715 34.6461C22.0615 30.1541 17.4175 28.6041 13.7635 27.4431C11.3505 26.6681 8.78953 25.5281 8.81553 24.2681C8.83553 23.2341 10.1855 22.2751 12.8685 22.4181C14.6685 22.5151 16.2585 22.6601 19.4215 24.1881L22.5315 18.7681C19.6475 17.3001 15.6595 16.3731 12.3895 16.3701H12.3695C8.55653 16.3701 5.38153 17.6051 3.41353 19.6401C2.04153 21.0601 1.30153 22.8661 1.27153 24.8631C1.22153 27.6111 2.22853 29.5591 4.34453 31.1161C6.13253 32.4261 8.41953 33.2761 10.4345 33.9001C12.9195 34.6701 14.9495 35.3401 14.9245 36.7661C14.9045 37.2861 14.7085 37.7721 14.3345 38.1641C13.7145 38.8041 12.7645 39.0441 11.4495 39.0701C8.91253 39.1241 7.03253 38.7251 4.03653 36.9541L1.26953 42.4441C4.26253 44.1461 7.43953 45.0001 11.0495 45.0001L11.8615 44.9941C15.0035 44.9371 17.5535 44.1841 19.5795 42.5541C19.6955 42.4611 19.7995 42.3671 19.9075 42.2721L19.5675 44.0241L27.1475 44.0001L28.5075 40.5181C29.9375 41.0061 31.5635 41.2761 33.2895 41.2761C34.9715 41.2761 36.5535 41.0201 37.9565 40.5601L38.9045 44.0001L52.5045 44.0131L52.5375 36.0751H55.4315C62.4265 36.0751 66.5615 32.5151 66.5615 26.5451C66.5595 19.8961 62.5395 17.0001 53.9835 17.0001ZM33.2895 35.0621C32.2445 35.0621 31.2645 34.8801 30.4215 34.5601L33.2575 25.6051H33.3125L36.1025 34.5851C35.2625 34.8851 34.3055 35.0621 33.2885 35.0621H33.2895ZM54.5095 29.9171H52.5355V22.7001H54.5105C57.1405 22.7001 59.2405 23.5761 59.2405 26.2621C59.2385 29.0421 57.1405 29.9171 54.5105 29.9171",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6658_126718",
    x1: 45.483,
    y1: 8,
    x2: 45.483,
    y2: 53.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#0097DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#007CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#006CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066B3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6658_126718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6658_126718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 45,
    fill: "white",
    transform: "translate(0 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSap);
export default __webpack_public_path__ + "static/media/sap.35f1990dfa658efcfe335b94b85e4cb8.svg";
export { ForwardRef as ReactComponent };